<template>
  <div>
    <div class="legend-line">
      <div v-if="[1,2,3,6].includes(keyType)">
        <div
          v-for="(item, index) in legendList"
          :key="index"
          class="legend-item"
        >
          <div
            class="circle"
            :style="`background: ${item.color}`"
          ></div>
          <div>{{ keyType == 2 ? item.name2 : keyType == 6 ? item.name3 : item.name1 }}</div>
        </div>
      </div>
      <div v-if="keyType == 4">
        <div
          v-for="(item, index) in electricLabelMap"
          :key="index"
          class="legend-item"
        >
          <div
            class="circle"
            :style="`background: ${item.color}`"
          ></div>
          <div>{{ machineNum == 3 ? item.name2 : item.name1 }}</div>
        </div>
      </div>
      <div v-if="keyType == 5">
        <div
          v-for="(item, index) in electricLabelMap2"
          :key="index"
          class="legend-item"
        >
          <div
            class="circle"
            :style="`background: ${item.color}`"
          ></div>
          <div>{{ machineNum == 3 ? item.name2 : item.name1 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    machineNum: {
      type: Number,
      default: 1
    },
    keyType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      legendList: [
        { name1: '0 - 1', name2: '0 - 0.1', name3: '49.3-54.1', color: '#accfff' },
        { name1: '1 - 80', name2: '0.1 - 5.8', name3: '54.2-58.9', color: '#1871fe' },
        { name1: '80 - 85', name2: '5.8 - 6.1', name3: '59.0-63.7', color: '#18c5fe' },
        { name1: '85 - 88', name2: '6.1 - 6.4', name3: '63.8-67.3', color: '#44dd9e' },
        { name1: '88 - 92', name2: '6.4 - 6.8', name3: '67.4-69.7', color: '#fff22f' },
        { name1: '92及以上', name2: '6.8及以上', name3: '69.8-73.3', color: '#f87c20' },
      ],
      electricLabelMap: [
        { name1: '0 - 0.1', name2: '0 - 0.1', color: '#accfff' },
        { name1: '0.1 - 10', name2: '0.1 - 60', color: '#1871fe' },
        { name1: '10 - 13', name2: '60 - 65', color: '#18c5fe' },
        { name1: '13 - 16', name2: '65 - 70', color: '#44dd9e' },
        { name1: '16 - 19', name2: '70 - 75', color: '#fff22f' },
        { name1: '19 - 24', name2: '75 - 86', color: '#f87c20' }
      ],
      electricLabelMap2: [
        { name1: '0 - 0.1', name2: '0 - 0.1', color: '#accfff' },
        { name1: '0.1 - 1.5', name2: '0.1 - 3', color: '#1871fe' },
        { name1: '1.5 - 2', name2: '3 - 5', color: '#18c5fe' },
        { name1: '2 - 2.5', name2: '5 - 7', color: '#44dd9e' },
        { name1: '2.5 - 3', name2: '7 - 9', color: '#fff22f' },
        { name1: '3及以上', name2: '9以上', color: '#f87c20' }
      ],
    }
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style scoped lang="scss">
.legend-line {
  color: #fff;
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  .legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    // width: 33.33%;
    .circle {
      width: 12px;
      height: 12px;
      border-radius: 20px;
      margin-right: 3px;
    }
  }
  &.legend1 {
    top: 20px;
  }
  &.legend2 {
    top: 50px;
  }

  .legend {
    color: #fff;
    position: relative;
    font-size: 15px;
    &:nth-child(1) {
      margin-right: 30px;
    }
    &:nth-child(2) {
      margin-right: 30px;
    }
    &.a:before {
      content: '';
      position: absolute;
      left: -20px; /* 将圆形置于文本左侧 */
      top: 50%;
      transform: translateY(-50%); /* 垂直居中对齐 */
      width: 12px; /* 圆形的宽度 */
      height: 12px; /* 圆形的高度 */
      background-color: #accfff; /* 圆形的背景颜色 */
      border-radius: 50%; /* 创建圆形 */
    }
    &.b:before {
      content: '';
      position: absolute;
      left: -20px; /* 将圆形置于文本左侧 */
      top: 40%;
      transform: translateY(-50%); /* 垂直居中对齐 */
      width: 12px; /* 圆形的宽度 */
      height: 12px; /* 圆形的高度 */
      background-color: #1871fe; /* 圆形的背景颜色 */
      border-radius: 50%; /* 创建圆形 */
    }
    &.c:before {
      content: '';
      position: absolute;
      left: -20px; /* 将圆形置于文本左侧 */
      top: 40%;
      transform: translateY(-50%); /* 垂直居中对齐 */
      width: 12px; /* 圆形的宽度 */
      height: 12px; /* 圆形的高度 */
      background-color: #18c5fe; /* 圆形的背景颜色 */
      border-radius: 50%; /* 创建圆形 */
    }
    &.d:before {
      content: '';
      position: absolute;
      left: -20px; /* 将圆形置于文本左侧 */
      top: 40%;
      transform: translateY(-50%); /* 垂直居中对齐 */
      width: 12px; /* 圆形的宽度 */
      height: 12px; /* 圆形的高度 */
      background-color: #44dd9e; /* 圆形的背景颜色 */
      border-radius: 50%; /* 创建圆形 */
    }
    &.e:before {
      content: '';
      position: absolute;
      left: -20px; /* 将圆形置于文本左侧 */
      top: 40%;
      transform: translateY(-50%); /* 垂直居中对齐 */
      width: 12px; /* 圆形的宽度 */
      height: 12px; /* 圆形的高度 */
      background-color: #fff22f; /* 圆形的背景颜色 */
      border-radius: 50%; /* 创建圆形 */
    }
    &.f:before {
      content: '';
      position: absolute;
      left: -20px; /* 将圆形置于文本左侧 */
      top: 50%;
      transform: translateY(-50%); /* 垂直居中对齐 */
      width: 12px; /* 圆形的宽度 */
      height: 12px; /* 圆形的高度 */
      background-color: #f87c20; /* 圆形的背景颜色 */
      border-radius: 50%; /* 创建圆形 */
    }
  }
}
</style>